import type { Fallacy } from "./types";
import { createStory } from "./types";

export const simpsonsParadox: Fallacy = {
    id: "simpsons-paradox",
    name: "Simpson's Paradox",
    emoji: "🔄",
    category: "Manipulasi Statistik",
    description: "Tren di beberapa kelompok data justru **terbalik ketika digabungkan**, atau sebaliknya.",
    tldr: "Data gabungan bilang A lebih baik, tapi kalau dipecah per kelompok, B yang menang.",
    detail: "Simpson's Paradox adalah fenomena statistik di mana tren pada beberapa kelompok data terpisah justru **berbalik arah ketika digabungkan**. Ini jebakan nyata dalam analisis data yang bisa menyesatkan bahkan para profesional.\n\nContoh terkenal: penerimaan mahasiswa di UC Berkeley 1973. Secara keseluruhan, persentase pria yang diterima lebih tinggi — mengindikasikan diskriminasi. Namun per departemen, wanita justru memiliki tingkat penerimaan sama atau lebih tinggi. Paradoksnya muncul karena wanita lebih banyak mendaftar ke departemen kompetitif dengan tingkat penerimaan rendah.\n\nKunci menghindarinya: selalu tanyakan apakah ada **variabel tersembunyi** (confounding variable) yang mempengaruhi data? Jangan pernah langsung percaya angka agregat tanpa melihat data yang lebih detail di bawahnya.",
    story: createStory("Simpson's Paradox", "🔄", {
      hook: {
        title: "Rumah sakit A angka kematiannya lebih tinggi.",
        body: "Jangan ke sana? Tunggu dulu — bisa jadi RS A justru yang lebih bagus.",
      },
      convo: {
        claim: "Jangan ke RS A deh, **tingkat kematiannya lebih tinggi** daripada RS B. Data gak bohong.",
        response: "RS A nanganin pasien berat. **Per kategori penyakit, justru RS A yang lebih bagus.**",
      },
      reveal: {
        body: "Tren di beberapa kelompok data **berbalik arah** pas digabungin. Data agregat bisa ceritain hal yang **berlawanan** sama kenyataan.",
      },
      insight: {
        title: "Kenapa bisa terbalik?",
        body: "Ada faktor yang gak keliatan — misalnya RS A nanganin kasus berat, jadi angka totalnya keliatan jelek. Padahal **per kategori, justru lebih bagus**.",
      },
      engagement: {
        title: "Pernah salah nilai sesuatu gara-gara cuma lihat angka totalnya? 🔄",
        body: "Di kampus, rumah sakit, atau kantor? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["misleading-statistics", "cherry-picking", "ecological-fallacy", "sampling-bias"],
  };
